var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdvantages1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1992_30737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 0C16.5655 0 0 16.5655 0 37C0 57.4344 16.5655 74 37 74C57.4344 74 74 57.4344 74 37C74 16.5655 57.4344 0 37 0ZM53.9048 45.3297L53.8904 53.746H29.089C27.971 53.746 26.8988 53.3019 26.1082 52.5113C25.3177 51.7208 24.8736 50.6486 24.8736 49.5306C24.8736 48.4126 25.3177 47.3404 26.1082 46.5499C26.8988 45.7594 27.971 45.3153 29.089 45.3153H40.2337L20.6149 25.6964C19.8243 24.9058 19.3801 23.8335 19.3801 22.7154C19.3801 21.5972 19.8243 20.5249 20.6149 19.7343C21.4055 18.9437 22.4779 18.4995 23.596 18.4995C24.7141 18.4995 25.7864 18.9437 26.5771 19.7343L45.474 38.6313V29.2622C45.474 28.1442 45.9182 27.072 46.7087 26.2815C47.4992 25.4909 48.5714 25.0468 49.6894 25.0468C50.8074 25.0468 51.8796 25.4909 52.6701 26.2815C53.4607 27.072 53.9048 28.1442 53.9048 29.2622V45.3297Z",
    fill: "#58A291"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1992_30737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvantages1);
export default __webpack_public_path__ + "static/media/icon-advantages-1.6f4af8d2273f72d13b4ca1f06392790d.svg";
export { ForwardRef as ReactComponent };